import backofficeService from '../../api/backoffice'

export default {
  /**
   * Get All location
   * @param {*} params Query Options
   */
  getAll(id, params) {
    return backofficeService.Api().get(`api/v2BarchReport/${id}`, { params })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  getTotalBatchCount(id, params) {
    return backofficeService.Api().get(`api/getTotalBatchCount/${id}`, { params })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  /**
   * Get location profile
   * @param {*} params Query Options
   */
  getById(id) {
    return backofficeService.Api().get(`api/v2BarchReport/view/${id}`)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  getByStoreId(id) {
    return backofficeService.Api().get(`api/v2BarchReport/store/${id}`)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  sendEmail(data) {
    return backofficeService.Api().post('cspApi/sendEmail', data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
}
